export const HOVER_MOUSE_ENTER = 'HOVER_MOUSE_ENTER'
export const HOVER_MOUSE_LEAVE = 'HOVER_MOUSE_LEAVE'
